import {Component, inject, Injectable, Pipe, PipeTransform} from '@angular/core';
import {ExportDataSettingBase} from '@shared/components/export-data/export-data-setting.base';
import {AppFormAddComponent} from '@shared/components/app-form';
import type {IProgressPaginator} from '@shared/services/global/excel.service';
import {FormatPercentPipe} from '@shared/pipes/global';

export type {IOptionsExportDataSetting as IOptionsExportDataExcelSetting} from '@shared/models/business/export-data-setting.model';

@Component({
  standalone: false,
  selector: 'app-export-data-excel-setting',
  templateUrl: 'export-data-excel-setting.component.html',
  providers: [AppFormAddComponent],
})
export class ExportDataExcelSettingModalComponent extends ExportDataSettingBase {
  protected readonly exportType = 'excel';
  private percent = inject(FormatPercentPipe);

  protected onProgress(progress: IProgressPaginator) {
    if (this.progressState.totalPages > 0 && this.progressState.currentPage > 0) {
      const percent = this.percent.transform((this.progressState.currentPage / this.progressState.totalPages) * 100) as number;
      this.progressState.isFinal = percent >= 100;
    }
  }

  onExportData() {
    if (this.progressState.isExportSubmit) return;
    const stat$ = {...this.state};
    this.errors = {};
    let isValid = true;
    if (!stat$.fileNew.fileName) {
      isValid = false;
      this.errors['fileNew.fileName'] = 'Tên bảng tính không được để trống';
    }
    if (!stat$.fileNew.sheetName) {
      isValid = false;
      this.errors['fileNew.sheetName'] = 'Tên trang tính không được để trống';
    }
    if (stat$.fileNew.sheetName.length > 31) {
      isValid = false;
      this.appForm.notifyWarning('common.sheetName.limit');
    }
    if (!isValid) return;
    this.progressState.isExportSubmit = true;
    this.output$.next(stat$);
  }

  onChangeFileSheetName(value: string) {
    const key = 'fileNew.sheetName';
    const maxLength = 31;
    if (value.length <= maxLength) {
      delete this.errors[key];
    } else {
      this.errors[key] = 'common.sheetName.limit';
    }
  }

}

@Pipe({
  name: 'columnIndexExcel',
  standalone: true,
})
@Injectable({
  providedIn: 'root'
})
export class ColumnIndexExcelPipe implements PipeTransform {
  transform(index: number): string {
    let columnName = '';
    let dividend = index + 1;
    let modulo: number;

    while (dividend > 0) {
      modulo = (dividend - 1) % 26;
      columnName = String.fromCharCode(65 + modulo) + columnName;
      dividend = Math.floor((dividend - modulo) / 26);
    }

    return columnName;
  }
}
